var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-wrapper1 bhxc-bg",
      class: { hideSidebar: !_vm.sidebar.opened },
      attrs: { id: "slxc" }
    },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "header-left" }),
              _c("div", { staticClass: "header-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "Backstage",
                    staticStyle: {
                      "line-height": "3.5vh",
                      height: "3.5vh",
                      display: "flex"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "0.8vw",
                          padding: "0.5vh 0.6vw"
                        }
                      },
                      [_vm._v("欢迎您! " + _vm._s(this.userName))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "out",
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.manage }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: {
                            src: "/web/static/img/overview/backstage.png"
                          }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.logout }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: { src: "/web/static/img/overview/layout.png" }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.getFullCreeen }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: {
                            src: "/web/static/img/overview/fullscreen.png"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "bhxcsq-new-dashboard-table",
          staticStyle: { padding: "0 10px", margin: "1.5vh 2vh 4vh 2vh" }
        },
        [
          _c(
            "el-col",
            { staticStyle: { height: "100%" }, attrs: { span: 7 } },
            [
              _c("div", { staticClass: "left" }, [
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/xindaping/new/baoxiugondan.png",
                          alt: ""
                        }
                      })
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "moduleContainer" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "warrantyChart-box" }, [
                              _c("div", { staticStyle: { height: "30%" } }, [
                                _c("div", { staticClass: "sheetTotalTitle" }, [
                                  _vm._v("工单总数")
                                ]),
                                _c("div", { staticClass: "sheetTotalNum" }, [
                                  _vm._v(_vm._s(_vm.workOrderTotal))
                                ])
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "68%",
                                    "margin-top": "1vh"
                                  }
                                },
                                [
                                  _c("workOrderFeedbackRate", {
                                    attrs: { chartData: _vm.workOrderRate }
                                  })
                                ],
                                1
                              )
                            ])
                          ]),
                          _c("el-col", { attrs: { span: 16 } }, [
                            _c(
                              "div",
                              { staticStyle: { height: "18vh" } },
                              [
                                _c("workOrderStatisticalBar", {
                                  attrs: { chartData: _vm.workOrderArray }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/xindaping/new/gaojing.png",
                          alt: ""
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "moduleContainer2" }, [
                    _c(
                      "div",
                      { staticClass: "complaints-chart" },
                      [
                        _c("sevenDaysLineChart", {
                          attrs: {
                            "legend-name": _vm.sevenDayLegendName,
                            "x-axis-data": _vm.sevenDayXData,
                            "chart-data": _vm.deviceAlarmCountData
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: { src: "/static/xindaping/tousu.png", alt: "" }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "moduleContainer2" }, [
                    _c(
                      "div",
                      { staticClass: "complaints-chart" },
                      [
                        _c("sevenDaysLineChart", {
                          attrs: {
                            "legend-name": _vm.sevenDayLegendName,
                            "x-axis-data": _vm.sevenDayXData,
                            "chart-data": _vm.complaintManageCountData
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/xindaping/new/baoxiu.png",
                          alt: ""
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "moduleContainer2" }, [
                    _c(
                      "div",
                      { staticClass: "complaints-chart" },
                      [
                        _c("sevenDaysLineChart", {
                          attrs: {
                            "legend-name": _vm.sevenDayLegendName,
                            "x-axis-data": _vm.sevenDayXData,
                            "chart-data": _vm.repairCountData
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _c(
            "el-col",
            { staticStyle: { height: "100%" }, attrs: { span: 10 } },
            [
              _c("div", [
                _c("div", { staticClass: "xin-title1" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/xindaping/new/ziyuan.png",
                        alt: ""
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer3" }, [
                  _c("div", { staticClass: "housing-content" }, [
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/xiaoqu.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(_vm.houseCount.communityCount)
                                )
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("小区总数")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/renkou.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(_vm.houseCount.peopleCount)
                                )
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("人口总数")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/yezhu.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.formatNum(_vm.houseCount.ownerCount))
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("业主总数")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/zuhu.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(_vm.houseCount.tenantCount)
                                )
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("租户总数")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/fangyuan.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.formatNum(_vm.houseCount.houseCount))
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("房源总数")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/zaizu.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(_vm.houseCount.inRentCount)
                                )
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("在租房间")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/hetong.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(_vm.houseCount.contractCount)
                                )
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("合同总数")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c("div", { staticClass: "card-wrapper" }, [
                        _c("div", { staticStyle: { height: "8vh" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1vh",
                                left: "2vh"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "7vh", width: "7vh" },
                                attrs: {
                                  src: "/static/xindaping/new/daoqi.png",
                                  alt: ""
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "num",
                              staticStyle: {
                                position: "absolute",
                                top: "4vh",
                                right: "0.5vh"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(
                                    _vm.houseCount.expireContractCount
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("到期合同")
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _c("div", { staticStyle: { width: "100%", height: "20vh" } }, [
                _c("div", { staticClass: "xin-title1" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/xindaping/new/shoufei.png",
                        alt: ""
                      }
                    })
                  ])
                ]),
                _c(
                  "div",
                  { staticStyle: { width: "100%", height: "16vh" } },
                  [
                    _c("feeLineChart", {
                      attrs: {
                        "legend-name": _vm.lendName4,
                        "x-axis-data": _vm.XData4,
                        "chart-data": _vm.chartData4,
                        total: _vm.total4
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", [
                _c("div", { staticClass: "xin-title1" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: { src: "/static/xindaping/qianfei.png", alt: "" }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer4" }, [
                  _c("div", { staticClass: "lack-content flex-sb" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "popper-class": _vm.customClass,
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { change: _vm.lackChooseData },
                          model: {
                            value: _vm.dates,
                            callback: function($$v) {
                              _vm.dates = $$v
                            },
                            expression: "dates"
                          }
                        }),
                        _c("lackStatisticalChart", {
                          attrs: {
                            chartData: _vm.chartData3,
                            lendName: _vm.lendName3,
                            total: _vm.total3
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "right bhxcsq-new-dashboard-table" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%", height: "28vh" },
                            attrs: {
                              data: _vm.recodeOutCount.chargeItemCountVos,
                              size: "small",
                              height: "28vh"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "communityName",
                                label: "小区名称",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "chargeName",
                                label: "收费项目",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "receivableAmount",
                                label: "应收",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "paidAmount",
                                label: "实收",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "unpaidAmount",
                                label: "欠费",
                                "show-overflow-tooltip": ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _c(
            "el-col",
            { staticStyle: { height: "100%" }, attrs: { span: 7 } },
            [
              _c("div", [
                _c("div", { staticClass: "xin-title" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/xindaping/new/shebei.png",
                        alt: ""
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer5" }, [
                  _c("div", { staticClass: "gaugeWrap" }, [
                    _c(
                      "div",
                      { staticClass: "gaugeItem" },
                      [
                        _c("deviceGauge", {
                          attrs: {
                            legendName: "正常百分比",
                            chartData: _vm.normalRate
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "gaugeItem" },
                      [
                        _c("deviceGauge", {
                          attrs: {
                            legendName: "故障百分比",
                            chartData: _vm.failureRate
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "gaugeItem" },
                      [
                        _c("deviceGauge", {
                          attrs: {
                            legendName: "离线百分比",
                            chartData: _vm.offlineRate
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "notice-content bhxcsq-new-dashboard-table table1",
                      staticStyle: { "margin-top": "-0.5vh" }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", height: "15vh" },
                          attrs: {
                            data: _vm.equipmentList,
                            size: "small",
                            height: "18vh"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "设备类型",
                              "show-overflow-tooltip": "",
                              "min-width": "120"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.deviceTypeName))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "总数",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.allNum))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "正常",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.normalNum))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "故障",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.offnormalNum))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "离线",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.faultNum))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", [
                _c("div", { staticClass: "xin-title" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/xindaping/new/shixiang.png",
                        alt: ""
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer7" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "notice-content bhxcsq-new-dashboard-table table1"
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", height: "18vh" },
                          attrs: {
                            data: _vm.noticeList,
                            "show-header": false,
                            size: "small",
                            height: "18vh"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "事项",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/xindaping/new/shixiangSmall.png",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(_vm._s(scope.row.eventName))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "数量",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.num) + "项")
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "xin-title" }, [
                _c("div", { staticClass: "xin-title-img" }, [
                  _c("img", {
                    attrs: { src: "/static/xindaping/new/huodong.png", alt: "" }
                  })
                ])
              ]),
              _c("div", { staticClass: "moduleContainer6" }, [
                _c(
                  "div",
                  {
                    staticClass: "picker-date",
                    staticStyle: { margin: "1vh 0 0 1vh" }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "260px" },
                      attrs: {
                        "popper-class": _vm.customClass,
                        type: "daterange",
                        "range-separator": "至",
                        "value-format": "yyyy-MM-dd",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期"
                      },
                      on: { change: _vm.activitydatesChange },
                      model: {
                        value: _vm.activitydates,
                        callback: function($$v) {
                          _vm.activitydates = $$v
                        },
                        expression: "activitydates"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      height: "17vh",
                      color: "#fff",
                      padding: "0 1vw"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          margin: "auto",
                          width: "90%"
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "12vh", height: "12vh" },
                          attrs: {
                            src: "/static/xindaping/new/huodongrenshu.png",
                            alt: ""
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("div", { staticClass: "gradient-text" }, [
                              _vm._v(_vm._s(_vm.activityData.allNum))
                            ]),
                            _c("div", [_vm._v("活动总数")])
                          ]
                        ),
                        _c("img", {
                          staticStyle: { width: "12vh", height: "12vh" },
                          attrs: {
                            src: "/static/xindaping/new/baoming.png",
                            alt: ""
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("div", { staticClass: "gradient-text" }, [
                              _vm._v(_vm._s(_vm.activityData.applyNum))
                            ]),
                            _c("div", [_vm._v("报名人数")])
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "margin-top": "-3.5vh"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "15vh",
                              height: "11vh",
                              background:
                                "url(/static/xindaping/new/huodongBg.png)",
                              "background-size": "100% 100%",
                              display: "flex",
                              "flex-direction": "column",
                              "align-items": "center",
                              padding: "2vh 0"
                            }
                          },
                          [
                            _c("div", { staticClass: "gradient-text" }, [
                              _vm._v(_vm._s(_vm.activityData.notStart))
                            ]),
                            _c("div", [_vm._v("未开始")])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "15vh",
                              height: "11vh",
                              background:
                                "url(/static/xindaping/new/huodongBg.png)",
                              "background-size": "100% 100%",
                              display: "flex",
                              "flex-direction": "column",
                              "align-items": "center",
                              padding: "2vh 0"
                            }
                          },
                          [
                            _c("div", { staticClass: "gradient-text" }, [
                              _vm._v(_vm._s(_vm.activityData.ongong))
                            ]),
                            _c("div", [_vm._v("进行中")])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "15vh",
                              height: "11vh",
                              background:
                                "url(/static/xindaping/new/huodongBg.png)",
                              "background-size": "100% 100%",
                              display: "flex",
                              "flex-direction": "column",
                              "align-items": "center",
                              padding: "2vh 0"
                            }
                          },
                          [
                            _c("div", { staticClass: "gradient-text" }, [
                              _vm._v(_vm._s(_vm.activityData.finished))
                            ]),
                            _c("div", [_vm._v("已结束")])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }